"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useQueryData_1 = require("./useQueryData");
function useGetMasterVolume() {
    const [volume, error] = (0, useQueryData_1.default)('game', 'master_volume');
    return [volume !== null && volume !== void 0 ? volume : 0.5, error]; // Default to 0.5 (50%) if data is missing so we don't annoy users with autoplaying sound
}
exports.default = useGetMasterVolume;
